export default {
  remove: '🗑️',
  edit: '✍️',
  save: '💾',
  ok: '✔️',
  wrong: '❌',
  empty: '⬜',
  running: '⌛',
  construction: '🚧',
  folder: '📁',
  files: '🗃️',
  plus: '➕',
  notebook:'🗒️',
  info: 'ℹ️',
  up: '⬆️',
  down:'⬇️',
}
